import { CommodityXref } from "../CommodityXref";
import { EdiApiUsers } from "../EdiApiUsers";
import { EdiDelayCodePartners } from "../EdiDelayCodePartners";
import { EdiEventStatusTable } from "../EdiEventStatusTable";
import { EdiNotify } from "../EdiNotify";
import { EdiPartnerQualifiers } from "../EdiPartnerQualifiers";
import { HandlingRequirementXref } from "../HandlingRequirementXref";
import { InboundFuncAck } from "../InboundFuncAck";
import { LocationCustomerXref } from "../LocationCustomerXref";
import { PackageTypeXref } from "../PackageTypeXref";
import { TrailerTypeXref } from "../TrailerTypeXref";
import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutStatusProfile extends Layout {
    buttonAckTemplateSetup: Button;
    buttonCustomFilename: Button;
    buttonCustomizeTransControNoi: Button;
    buttonFilenameCustomize: Button;
    buttonFuncAckMasterBatch: Button;
    buttonMasterBatch: Button;
    buttonOpenClassic: Button;
    buttonSchedule: Button;
    buttonSetup: Button;
    buttonTransactionCustomize: Button;
    checkboxConsStops: Checkbox;
    checkboxFuncUseMBatch: Checkbox;
    checkboxIndividualBatch: Checkbox;
    checkboxIntercompany: Checkbox;
    checkboxSendFuncAck: Checkbox;
    checkboxSkipManualOrders: Checkbox;
    checkboxStatusOnDelivery: Checkbox;
    checkboxStatusOnPickup: Checkbox;
    checkboxUseMBatch: Checkbox;
    dataheaderStatusProfile: DataHeader;
    labelAuditStatuses: Label;
    labelAuditStatusesIn: Label;
    labelAuditWarning: Label;
    labelDays: Label;
    labelDaysIn: Label;
    labelDirectionOutbound: Label;
    labelFuncMasterBatch: Label;
    labelHours: Label;
    labelHoursIn: Label;
    labelLocationBasedStatuses: Label;
    labelMinutesFor: Label;
    labelMinutesForIn: Label;
    labelNextBatchNumber: Label;
    layoutCommodityXref: CommodityXref;
    layoutEdiApiUsers: EdiApiUsers;
    layoutEdiDelayCodePartners: EdiDelayCodePartners;
    layoutEdiNotify: EdiNotify;
    layoutEdiPartnerQualifiers: EdiPartnerQualifiers;
    layoutHandlingRequirementXref: HandlingRequirementXref;
    layoutInboundFuncAck: InboundFuncAck;
    layoutLocationCustomerXref: LocationCustomerXref;
    layoutPackagingTypeCode: PackageTypeXref;
    layoutStatusEvent: EdiEventStatusTable;
    layoutTrailerType: TrailerTypeXref;
    panelAuditStatuses: Panel;
    panelAuditStatusesIn: Panel;
    panelCrossReferences: Panel;
    panelFuncBatch: Panel;
    panelGeneralInbound: Panel;
    panelGeneralOutbound: Panel;
    panelHeader: Panel;
    panelInboundFuncAck: Panel;
    panelNotes: Panel;
    panelOutboundFuncAck: Panel;
    panelShipMatchCrit: Panel;
    sourceEdiApiUser: DataSource;
    sourceEdiCarrier: DataSource;
    sourceEdiCommodity: DataSource;
    sourceEdiCrossRefHandlingRequirement: DataSource;
    sourceEdiCrossRefPackageTypeCode: DataSource;
    sourceEdiCrossRefTrailerType: DataSource;
    sourceEdiCustomer: DataSource;
    sourceEdiDataRule: DataSource;
    sourceEdiDelayCode: DataSource;
    sourceEdiNotify: DataSource;
    sourceEdiPartnerCodeDetail: DataSource;
    sourceEdiRequiredField: DataSource;
    sourceEdiShipmatchCrit: DataSource;
    sourceEdiShipmatchRule: DataSource;
    sourceEdilocation: DataSource;
    sourceEdistatusProfileDisplay: DataSource;
    sourceEdistatuseventTable: DataSource;
    tabAPIUser: Tab;
    tabAcknowledgement: Tab;
    tabCarrier: Tab;
    tabCrossReferences: Tab;
    tabCustomers: Tab;
    tabDataValidation: Tab;
    tabEvents: Tab;
    tabGeneral: Tab;
    tabNotifications: Tab;
    tabPartnerDelayCodes: Tab;
    tabPartnerNotes: Tab;
    tabPartnerQual: Tab;
    tabShipmentMatching: Tab;
    tableEdiCarrier: Table;
    tableEdiCustomer: Table;
    tableRequiredField: Table;
    tableShipMatchCrit: Table;
    tabsetStatusProfile: Tabset;
    textboxAckXmitMethod: Textbox;
    textboxAltPartnerId: Textbox;
    textboxAuditCutoffDays: Textbox;
    textboxAuditCutoffDaysIn: Textbox;
    textboxBatchMethod: Textbox;
    textboxCommId: Textbox;
    textboxDestStopNo: Textbox;
    textboxDirection: Textbox;
    textboxFaThreshold: Textbox;
    textboxFilename: Textbox;
    textboxFuncAckFilename: Textbox;
    textboxFuncAckSt02Frmt: Textbox;
    textboxFuncAckTid: Textbox;
    textboxFuncAltpartnerId: Textbox;
    textboxFuncCommId: Textbox;
    textboxFuncNextBatch: Textbox;
    textboxFuncPartnerId: Textbox;
    textboxFuncVersion: Textbox;
    textboxHoldType: Textbox;
    textboxIntervalHours: Textbox;
    textboxIntervalHoursIn: Textbox;
    textboxIntervalMinutes: Textbox;
    textboxIntervalMinutesIn: Textbox;
    textboxNextBatch: Textbox;
    textboxNotes: Textbox;
    textboxOrigStopNo: Textbox;
    textboxPartnerId: Textbox;
    textboxPartnerName: Textbox;
    textboxProcessPriority: Textbox;
    textboxSendToCompany: Textbox;
    textboxSt02Format: Textbox;
    textboxTemplateId: Textbox;
    textboxTransactionSet: Textbox;
    textboxTransmitMethod: Textbox;
    textboxVersion: Textbox;
}
